import ModulePropertiesPane from '../_MODULE/ModulePropertiesPane.jsx'
import Check from '../../SidePanel/RightPanel/PropertiesControllerCheck.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonCode from './PropertiesPaneButtonCode.jsx'
import ButtonExportXml from './PropertiesPaneButtonExportXml.jsx'
import Model from './ModelVm.mjs'

import {
    PropertiesPaneButtonIntegrateMap as ButtonIntegrateMap,
    PropertiesPaneButtonClearMap as ButtonClearMap,
} from './PropertiesPaneButtonIntegrateMap.jsx'

const PropertiesPaneVm = (props) => (
    <ModulePropertiesPane
        buttons={
            <>
                <ButtonCode />
                <ButtonExportXml nodes={props.nodes} />
                <ButtonIntegrateMap />
                <ButtonClearMap />
            </>
        }

        controllers={
            <>
                <Text prop="vmUserCode" />
                <Text prop="vmName" />
                <Text prop="vmPack" />
                <Check prop="isClass" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        versionLabel="程序地图版本号"
        {...props}
    />
)

export default PropertiesPaneVm
